import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const NavBar = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState([]);

  useEffect(() => {
    setActiveTab(location.pathname);
  }, [location.pathname]);

  return (
    <>
      <div class="screen-overlay"></div>
      <aside class="navbar-aside" id="offcanvas_aside">
        <div class="aside-top">
          <Link to="admin-dashboard" class="brand-wrap">
            <img
              src="/assets/imgs/theme/logo.svg"
              class="logo"
              alt="Nest Dashboard"
            />
          </Link>
          <div>
            <button class="btn btn-icon btn-aside-minimize">
              <i class="text-muted material-icons md-menu_open"></i>
            </button>
          </div>
        </div>
        <nav>
          <ul class="menu-aside">
            <li class={activeTab === '/admin-dashboard' ? "menu-item active" : "menu-item"}>
              <Link to="admin-dashboard" class="menu-link ">
                <i class="icon material-icons md-home"></i>
                <span class="text">Dashboard</span>
              </Link>
            </li>
            <li class={activeTab === '/products' ? "menu-item active" : "menu-item"}>
              <Link class="menu-link" to="/products">
                <i class="icon material-icons md-shopping_bag"></i>{" "}
                <span class="text">Products</span>
              </Link>
            </li>
            {/* <li class="menu-item has-submenu">
              <a class="menu-link" href="#">
                <i class="icon material-icons md-shopping_bag"></i>
                <span class="text">Products</span>
              </a>
              <div class="submenu">
                <a href="/product-category">Categories</a>
                <a href="/products">Product List</a>
                {/* <a href="/product-grid">Product grid</a>
              </div>
            </li> */}
            {/* <li class="menu-item">
              <a class="menu-link" href="/brands">
                <i class="icon material-icons md-stars"></i>{" "}
                <span class="text">Brands</span>
              </a>
            </li> */}
            <li class={activeTab === '/categories' ? "menu-item active" : "menu-item"}>
              <Link class="menu-link" to="/categories">
                <i class="icon material-icons md-stars"></i>{" "}
                <span class="text">Categories</span>
              </Link>
            </li>
            <li class={activeTab === '/orders' ? "menu-item active" : "menu-item"}>
              <Link class="menu-link" to="/orders">
                <i class="icon material-icons md-shopping_cart"></i>
                <span class="text">Orders</span>
              </Link>
              {/* <div class="submenu">
                <a href="/orderlist-1">Order list</a>
              </div> */}
            </li>

            <li class={activeTab === '/transactions' ? "menu-item active" : "menu-item"}>
              <Link class="menu-link" to="/transactions">
                <i class="icon material-icons md-monetization_on"></i>
                <span class="text">Transactions</span>
              </Link>
              {/* <div class="submenu">
                <a href="/transactions">Transaction</a>
              </div> */}
            </li>
            <li class={activeTab === '/banners' ? "menu-item active" : "menu-item"}>
              <Link class="menu-link" to="/banners">
                {/* <i class="icon material-icons md-monetization_on"></i> */}
                <span class="text">Banners</span>
              </Link>
              {/* <div class="submenu">
                <a href="/transactions">Transaction</a>
              </div> */}
            </li>
            {/* <li class='menu-item has-submenu'>
							<a class='menu-link' href='#'>
								<i class='icon material-icons md-person'></i>
								<span class='text'>Account</span>
							</a>
							<div className='submenu'>
								<a href='/admin-login'>User login</a>
								<a href='/admin-registration'>User registration</a>
								<a href='/error404-page'>Error 404</a>
							</div>
						</li> */}
            <li class={activeTab === '/reviews' ? "menu-item active" : "menu-item"}>
              <a class="menu-link" href="/reviews">
                <i class="icon material-icons md-comment"></i>
                <span class="text">Reviews</span>
              </a>
            </li>
          </ul>
          <hr />
          <ul class="menu-aside">
            <li class={activeTab === '/settings' ? "menu-item has-submenu active" : "menu-item has-submenu"}>
              <a class="menu-link">
                <i class="icon material-icons md-settings"></i>
                <span class="text">Settings</span>
              </a>
              <div class="submenu">
                <Link to="/settings">Profile</Link>
                <Link to="/customer-list">Customers</Link>
                <Link to="admin-management">Admins</Link>
              </div>
            </li>
          </ul>
          <br />
          <br />
        </nav>
      </aside>
    </>
  );
};

export default NavBar;
